<template>
  <v-card-text>
    <v-radio-group v-model="dataModel[modifyIndex].isCancer" true-value="true" false-value="false">
      <v-radio label="Yes" :value="true"></v-radio>
      <v-radio label="No" :value="false"></v-radio>
    </v-radio-group>
    <Cancercombobox v-if="dataModel[modifyIndex].isCancer === true" :modifyIndex="modifyIndex"/>
  </v-card-text>
</template>

<script>
import Cancercombobox from "../../questionnaire/PatientFormComp/CancerComboBox";
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    modifyIndex: Number
  },
  components: {
    Cancercombobox
  },
  mounted() {},
  methods: {
    remove(item) {
      const index = this.dataModel[this.modifyIndex].cancerConditions.indexOf(
        item
      );
      if (index >= 0)
        this.dataModel[this.modifyIndex].cancerConditions.splice(index, 1);
      delete this.dataModel[this.modifyIndex].cancerConditionsDx[item];
    }
  },
  data: () => ({}),
  computed: {
    ...mapFields("patientQuestion", ["dataModel", "cancerList"])
  }
};
</script>
